var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('head-bar'),(_vm.$store.state.loginButton)?_c('login'):_vm._e(),_c('div',{attrs:{"id":"router"}},[_c('router-view')],1),_c('tail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }